import { Injectable, signal } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class BlockDocumentUiState {
  private readonly _blocked = signal<boolean>(false);

  readonly blocked = this._blocked.asReadonly();

  setBlocked(value: boolean): void {
    this._blocked.set(value);
  }
}
